import React from 'react';
import AntTitle, { TitleProps } from 'antd/lib/typography/Title';

export default function Title({ children, ...props }: TitleProps) {
  return <AntTitle {...props}>{children}</AntTitle>;
}
